// @ts-nocheck
/* Options:
Date: 2026-04-20 15:17:29
Version: 8.80
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:35432

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IDelete
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export class Translation
{
    [immerable]? = true;

    public id?: number;
    public localeId?: number;
    public namespaceId?: number;
    public key?: string;
    public value?: string;
    public version?: number;

    public constructor(init?: Partial<Translation>) { (Object as any).assign(this, init); }
}

export enum PatientStateType
{
    Baseline = 1,
    Cycle2 = 2,
    Cycle3 = 3,
    EndOfTreatment = 4,
    Ineligible = 5,
    Withdrawn = 6,
}

export enum EventDefinitionType
{
    Baseline = 1,
    Cycle2 = 2,
    Cycle3 = 3,
    EndOfTreatment = 4,
    Withdrawal = 5,
}

export enum LookupEthnicityType
{
    White = 1,
    Black = 2,
    Asian = 3,
    Other = 4,
}

export enum LookupNoYesType
{
    No = 0,
    Yes = 1,
}

export enum LookupKnownUnknownType
{
    Known = 1,
    Unknown = 2,
}

export enum LookupYesNoUnknownType
{
    Yes = 1,
    No = 2,
    Unknown = 3,
}

export enum LookupEotReasonType
{
    Toxicity = 1,
    ProgressiveDisease = 2,
    ProtocolDefinedEot = 3,
    InvestigatorDecision = 4,
    Death = 5,
    PatientDecision = 6,
    Other = 7,
}

export enum LookupNumberDoseReductionsType
{
    One = 1,
    Two = 2,
    Three = 3,
    Other = 4,
}

export enum LookupSexType
{
    Female = 1,
    Male = 2,
}

export enum LookupIneligibleReasonType
{
    InclusionEighteenYearsOrOlder = 1,
    InclusionMetatstaticAdvancedHer2 = 2,
    InclusionPlannedTdxdTreatment = 3,
    InclusionLifeExpectancyFourMonths = 4,
    ExclusionDecreasedFoodIntake = 5,
    ExclusionParenteralNutrition = 6,
    ExlusionCachexiaUnrelatedToCancer = 7,
    ExlusionCalorieRestrictedDiet = 8,
    ParticipantDeclined = 9,
    OtherSpecify = 10,
}

export enum LookupGenderType
{
    WomanOrFemale = 1,
    ManOrMale = 2,
    NonBinary = 3,
    Other = 4,
}

// @DataContract
export class FileUploadTemporary implements IFileUploadTemporary
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public extension: string;

    // @DataMember(Order=4)
    public fileSize?: number;

    // @DataMember(Order=5)
    public contentType: string;

    // @DataMember(Order=6)
    public image: boolean;

    public constructor(init?: Partial<FileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class File
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public propertyName: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    // @Ignore()
    public upload: FileUploadTemporary;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IEventDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IEventDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IEventDefinitionGetCollection extends IGet
{
}

export interface IFormDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IFormDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IFormDefinitionGetCollection extends IGet
{
}

export interface IPatientStateGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientStateGetCollection extends IGet
{
}

export interface ITreatmentGetSingleById extends IGet
{
    id?: number;
}

export interface ITreatmentGetCollection extends IGet
{
}

export interface IMasterGroupGetSingleById extends IGet
{
    id?: number;
}

export interface IMasterGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface IMasterGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetSingleById extends IGet
{
    id?: number;
}

export interface ICollaboratingGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface ICollaboratingGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICollaboratingGroupGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetSingleById extends IGet
{
    id?: number;
}

export interface ICountryGetSingleByCode extends IGet
{
    code: string;
}

export interface ICountryGetCollection extends IGet
{
}

export interface ICountryGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICountryGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
}

export interface ICountryGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
}

export interface IInstitutionGetSingleById extends IGet
{
    id?: number;
}

export interface IInstitutionGetSingleByCode extends IGet
{
    code: string;
}

export interface IInstitutionGetCollection extends IGet
{
}

export interface IInstitutionGetCollectionByCountryId extends IGet
{
    countryId?: number;
}

export interface IInstitutionGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCountryCode extends IGet
{
    countryCode: string;
}

export interface IInstitutionGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
}

export interface IInstitutionGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
}

export interface IPatientGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientGetSingleByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetValidationById extends IGet
{
    id?: number;
    patientOnly?: boolean;
}

export interface IPatientGetValidationByStudyNumber extends IGet
{
    studyNumber: string;
    patientOnly?: boolean;
}

export interface IPatientGetCollection extends IGet
{
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryId extends IGet
{
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionId extends IGet
{
    institutionId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryCode extends IGet
{
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
    patientStateIds: number[];
}

export class PatientStatusLog
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public patientStateId?: number;
    public notes?: string;
    public enteredDate?: string;
    public enteredBy?: string;

    public constructor(init?: Partial<PatientStatusLog>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Patient implements IPatient, IRegistrationPatient
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public studyNumber: string;

    // @DataMember(Order=3)
    public temporaryNumber: string;

    // @DataMember(Order=4)
    public registrationNumber: string;

    // @DataMember(Order=5)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.Treatment)")
    public treatmentId?: number;

    // @DataMember(Order=6)
    public enrollingInstitutionId?: number;

    // @DataMember(Order=7)
    public enrollingInstitutionCode?: string;

    // @DataMember(Order=8)
    public institutionId?: number;

    // @DataMember(Order=9)
    public institutionCode?: string;

    // @DataMember(Order=10)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.PatientState)")
    public patientStateId?: number;

    // @DataMember(Order=11)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.PatientState)")
    public previousPatientStateId?: number;

    // @DataMember(Order=12)
    public patientStateChangeDate?: string;

    // @DataMember(Order=13)
    public initials?: string;

    // @DataMember(Order=14)
    public screeningDate?: string;

    // @DataMember(Order=15)
    public consentDate?: string;

    // @DataMember(Order=16)
    public registrationDate?: string;

    // @DataMember(Order=17)
    public enrolmentDate?: string;

    // @DataMember(Order=18)
    public reviewDate?: string;

    // @DataMember(Order=19)
    public treatmentAllocationDate?: string;

    // @DataMember(Order=20)
    public enteredDate?: string;

    // @DataMember(Order=21)
    public enteredBy: string;

    // @DataMember(Order=22)
    public modifiedDate?: string;

    // @DataMember(Order=23)
    public modifiedBy: string;

    // @DataMember(Order=24)
    public email?: string;

    // @DataMember(Order=25)
    public account?: boolean;

    // @DataMember(Order=26)
    public firstName?: string;

    // @DataMember(Order=27)
    public patientStatusLogs: PatientStatusLog[] = [];

    // @DataMember(Order=29)
    // @Ignore()
    public ineligibleReason?: string;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export interface IEventGetValidationByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    eventOnly?: boolean;
}

export interface IEventGetSingleById extends IGet
{
    id?: number;
}

export interface IEventGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetCollection extends IGet
{
}

export interface IEventGetCollectionByPatientId extends IGet
{
    patientId?: number;
}

export interface IEventGetCollectionByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
}

export class Event implements IEvent
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventDefinitionId?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Event>) { (Object as any).assign(this, init); }
}

export interface IFormGetSingleById extends IGet
{
    id?: number;
}

export interface IFormGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetCollection extends IGet
{
}

export interface IFormGetCollectionByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export interface IFormGetCollectionByCodes extends IGet
{
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
}

export class AdverseEventForm implements IForm
{
    [immerable]? = true;

    public id?: number;
    public ctcaeTermId?: number;
    public ctcaeCategoryId?: number;
    public ctcaeGradeId?: number;
    public ctcaeTermSpecify?: string;
    public onsetDate?: string;
    public resolutionDate?: string;
    public ongoing?: boolean;
    public relatedness?: number;
    public actionTaken?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<AdverseEventForm>) { (Object as any).assign(this, init); }
}

export enum FormStatusType
{
    DataEntry = 1,
    Locked = 2,
}

export interface IFormPostUpdateStatusByIds
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    formRepeat?: number;
    formStatus?: FormStatusType;
}

export class AdverseEventsForm implements IForm
{
    [immerable]? = true;

    public id?: number;
    public adverseEventForms?: AdverseEventForm[];
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<AdverseEventsForm>) { (Object as any).assign(this, init); }
}

export class BaselineDemographicsForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formStatus?: FormStatusType;
    public initials?: string;
    public dob?: string;
    public sex?: number;
    public gender?: number;
    public genderOtherSpecify?: string;
    public postcode?: string;
    public ethnicity?: number;
    public ethnicityUnknown?: boolean;
    public birthCountry?: number;
    public birthCountryOther?: boolean;
    public birthCountryOtherSpecify?: string;
    public primaryLanguageAsChild?: number;
    public primaryLanguageAsChildOther?: boolean;
    public primaryLanguageAsChildOtherSpecify?: string;
    public primaryNonEnglishLanguage?: number;
    public primaryNonEnglishLanguageOther?: boolean;
    public primaryNonEnglishLanguageOtherSpecify?: string;
    public menopauseStatus?: number;
    public institutionId?: number;
    public deNovoMetastaticDisease?: number;
    public primaryDiagnosisDate?: string;
    public metastaticDiagnosisDate?: string;
    public diseaseFreeInterval?: number;
    public erStatus?: number;
    public prStatus?: number;
    public her2Status?: number;
    public her2Ihc?: number;
    public her2CopyNumberStatus?: number;
    public her2CopyNumberValue?: number;
    public linesPreviousTherapy?: number;
    public ecog?: number;
    public height?: number;
    public weight?: number;
    public bmi?: number;
    public priorPregnancy?: number;
    public gravidity?: string;
    public parity?: string;
    public pregnancyRelatedNausea?: number;
    public patientConsentDate?: string;
    public ecogAssessmentDate?: string;
    public weightAssessmentDate?: string;

    public constructor(init?: Partial<BaselineDemographicsForm>) { (Object as any).assign(this, init); }
}

export class BloodCollectionForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formStatus?: FormStatusType;
    public bloodCollected?: number;
    public collectionDate?: string;
    public reasonForNonCollection?: string;
    public plasmaCollected?: boolean;
    public nlcCollected?: boolean;
    public pbmcCollected?: boolean;
    public samplesShippedToCentralLab?: number;
    public dateSamplesShipped?: string;

    public constructor(init?: Partial<BloodCollectionForm>) { (Object as any).assign(this, init); }
}

export class EndOfTreatmentForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formStatus?: FormStatusType;
    public lastCycleDate?: string;
    public totalCyclesReceived?: number;
    public eotReason?: number;
    public doseReduction?: number;
    public numberDoseReductions?: number;
    public numberDoseReductionsOtherSpecify?: string;
    public numCyclesBeforeFirstReduction?: number;
    public numCyclesBeforeSecondReduction?: number;
    public numCyclesBeforeThirdReduction?: number;
    public doseReductionNumCyclesOther?: string;
    public eotOtherSpecify?: string;
    public dateOfDeath?: string;
    public dateOfProgression?: string;
    public response?: number;
    public additionalInformation?: string;
    public dateOfConsentWithdrawal?: string;
    public consentedToContinuedSampleUse?: number;
    public consentedToFutureUnspecifiedSampleUse?: number;
    public lastDateOfDiseaseAssessments?: string;

    public constructor(init?: Partial<EndOfTreatmentForm>) { (Object as any).assign(this, init); }
}

export enum LookupBloodStorageConsentType
{
    Consented = 1,
    DidNotConsent = 2,
}

export class RegistrationForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formStatus?: FormStatusType;
    public instId?: number;
    public initials?: string;
    public dob?: string;
    public consentDate?: string;
    public consentedToBloodStorage?: LookupBloodStorageConsentType;

    public constructor(init?: Partial<RegistrationForm>) { (Object as any).assign(this, init); }
}

export class VisitDetailsForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formStatus?: FormStatusType;
    public visitDate?: string;
    public administrationDate?: string;
    public weight?: number;
    public weightDifference?: number;
    public dateStartTdxD?: string;
    public newAdverseEvents?: number;
    // @Ignore()
    public adverseEventsForm?: AdverseEventsForm;

    public constructor(init?: Partial<VisitDetailsForm>) { (Object as any).assign(this, init); }
}

export class WithdrawalForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formStatus?: FormStatusType;
    public consentWithdrawalDate?: string;
    public contact?: number;
    public healthInformation?: number;
    public sample?: number;
    public sampleFuture?: number;

    public constructor(init?: Partial<WithdrawalForm>) { (Object as any).assign(this, init); }
}

export interface IQueryGetSingleById extends IGet
{
    id?: number;
}

export interface IQueryGetCollection extends IGet
{
}

export interface IQueryGetCollectionByForm extends IGet
{
    formDefinitionId?: number;
    formId?: number;
}

export interface IQueryGetCollectionByFormProperty extends IGet
{
    formDefinitionId?: number;
    formId?: number;
    propertyPath?: string;
}

export enum QueryType
{
    Query = 1,
    ProtocolDeviation = 2,
}

export enum QueryStatusType
{
    Open = 1,
    ResolutionProposed = 2,
    Closed = 3,
}

export enum QueryActionType
{
    Open = 1,
    ProposeResolution = 2,
    RejectResolution = 3,
    Close = 4,
    AddInformation = 5,
}

export class Subquery implements ISubquery
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Data.Query)")
    public queryId?: number;

    public action?: QueryActionType;
    public comments?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Subquery>) { (Object as any).assign(this, init); }
}

export class Query implements IQuery
{
    [immerable]? = true;

    public id?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public queryType?: QueryType;
    public queryStatus?: QueryStatusType;
    public title?: string;
    public propertyPath?: string;
    public subqueries?: Subquery[];
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Query>) { (Object as any).assign(this, init); }
}

export interface IQueryDeleteById extends IDelete
{
    queryId?: number;
}

export interface ISubqueryGetCollectionByQueryId extends IGet
{
    queryId?: number;
}

export interface IPatientGetEventStatesById extends IGet
{
    id?: number;
}

export interface IPatientGetEventStatesByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetFormStatesByIds extends IGet
{
    id?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EConsentView = 40,
    EConsentAdminister = 41,
    EConsentManage = 42,
    PISignOffView = 43,
    PISignOffPerform = 44,
    PISignOffAdminister = 45,
    OpmsDataManage = 46,
    RedactVerificationAccess = 47,
    ReconsentAdminister = 48,
    TrialManagementAccess = 49,
    SourceDataVerificationAccess = 50,
    TrialParticipantAccess = 51,
    StaffTrainingAccess = 52,
    TrainingAccess = 53,
    ReportAccess = 54,
    WebsiteImporterAccess = 55,
    ConstituentManagerAccess = 56,
    OpmsBypassErrors = 57,
    RadiologyReviewAccess = 58,
    ApproveInvoice = 59,
    PrescreeningAccess = 60,
    PrescreeningAdminister = 61,
    InvoiceExportView = 62,
    InvoiceExportUpdate = 63,
    InvoiceRequisitionView = 64,
    InvoiceRequisitionUpdate = 65,
    CanCentralReview = 66,
    InvoiceView = 67,
    InvoiceUpdate = 68,
    IsSiteUser = 69,
    TissueBankAdmin = 70,
    CanViewQuerySummaries = 71,
}

export enum FormType
{
    Crf = 1,
    Pro = 2,
    Staff = 3,
}

export enum ValidationErrorType
{
    Warning = 1,
    Ineligible = 2,
    Normal = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName: string;
    public label: string;
    public detailedLabel: string;
    public errorMessages: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public type?: FormType;
    public name: string;
    public instructions: string;
    public patientInstructions: string;
    public properties: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties: { [index:string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinitionState implements IEventDefinitionFormDefinitionState
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinitionFormDefinition)")
    public eventDefinitionFormDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manage?: boolean;

    public constructor(init?: Partial<EventDefinitionFormDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinition
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public states: EventDefinitionFormDefinitionState[];

    public constructor(init?: Partial<EventDefinitionFormDefinition>) { (Object as any).assign(this, init); }
}

export class EventDefinitionState implements IEventDefinitionState
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manageForms?: boolean;

    public constructor(init?: Partial<EventDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionErrorMessage implements IEventDefinitionErrorMessage
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventDefinitionErrorMessage>) { (Object as any).assign(this, init); }
}

export class EventDefinition
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public code: string;
    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public formDefinitions: EventDefinitionFormDefinition[];
    public states: EventDefinitionState[];
    public errorMessages: EventDefinitionErrorMessage[];

    public constructor(init?: Partial<EventDefinition>) { (Object as any).assign(this, init); }
}

export class PatientState implements IPatientState
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public order?: number;

    public constructor(init?: Partial<PatientState>) { (Object as any).assign(this, init); }
}

export class Treatment implements ITreatment
{
    [immerable]? = true;

    public id?: number;
    public name: string;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable]? = true;

    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable]? = true;

    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export class Locale
{
    [immerable]? = true;

    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<Locale>) { (Object as any).assign(this, init); }
}

export class Namespace
{
    [immerable]? = true;

    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<Namespace>) { (Object as any).assign(this, init); }
}

export class PatientQuerySummary
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public eventName?: string;

    // @DataMember(Order=3)
    public formName?: string;

    // @DataMember(Order=4)
    public fieldName?: string;

    // @DataMember(Order=5)
    public type?: QueryType;

    // @DataMember(Order=6)
    public status?: QueryStatusType;

    // @DataMember(Order=7)
    public title?: string;

    // @DataMember(Order=8)
    public enteredBy?: string;

    // @DataMember(Order=9)
    public dateEntered?: string;

    public constructor(init?: Partial<PatientQuerySummary>) { (Object as any).assign(this, init); }
}

export class QuerySummary
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public institutionId?: number;

    // @DataMember(Order=3)
    public patientId?: number;

    // @DataMember(Order=4)
    public eventName?: string;

    // @DataMember(Order=5)
    public formName?: string;

    // @DataMember(Order=6)
    public fieldName?: string;

    // @DataMember(Order=7)
    public type?: QueryType;

    // @DataMember(Order=8)
    public status?: QueryStatusType;

    // @DataMember(Order=9)
    public title?: string;

    // @DataMember(Order=10)
    public enteredBy?: string;

    // @DataMember(Order=11)
    public dateEntered?: string;

    public constructor(init?: Partial<QuerySummary>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IFormValidationError extends IValidationError
{
    property: string;
}

export interface IFormValidationResult extends IValidationResult
{
    totalQueries?: number;
    queryStatuses?: { [index:string]: number; };
    answeredQuestions?: number;
    totalQuestions?: number;
    formId?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    formStatus?: FormStatusType;
    completed?: boolean;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    manage?: boolean;
    errors: IFormValidationError[];
}

export interface IFileUploadTemporary
{
    guid: string;
    name: string;
    extension: string;
    fileSize?: number;
    contentType: string;
    image: boolean;
}

export enum UserType
{
    TrialPersonnel = 1,
    Patient = 2,
}

export class LookupItem implements ILookupItem
{
    [immerable]? = true;

    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable]? = true;

    public propertyName: string;
    public items: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    [immerable]? = true;

    public formDefinitionId?: number;
    public formDefinitionCode: string;
    public name: string;
    public propertyName: string;
    public title: string;
    public instructions: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class MasterGroup implements IMasterGroup
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MasterGroup>) { (Object as any).assign(this, init); }
}

export class CollaboratingGroup implements ICollaboratingGroup
{
    [immerable]? = true;

    public id?: number;
    public masterGroupId?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CollaboratingGroup>) { (Object as any).assign(this, init); }
}

export class Country implements ICountry
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Country>) { (Object as any).assign(this, init); }
}

export class Institution implements IInstitution
{
    [immerable]? = true;

    public id?: number;
    public countryId?: number;
    public masterGroupId?: number;
    public collaboratingGroupId?: number;
    public code: string;
    public name: string;
    public enabled?: boolean;
    public activatedDate?: string;
    public recruitmentDisabled?: boolean;
    public eConsentActivationDate?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Ineligible = 2,
    Error = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class PatientValidationError implements IPatientValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<PatientValidationError>) { (Object as any).assign(this, init); }
}

export class EventValidationError implements IEventValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventValidationError>) { (Object as any).assign(this, init); }
}

export class FormValidationError implements IFormValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormValidationError>) { (Object as any).assign(this, init); }
}

export class FormValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public totalQueries?: number;
    public queryStatuses?: { [index:string]: number; };
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public formId?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public formStatus?: FormStatusType;
    public completed?: boolean;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manage?: boolean;
    public errors: FormValidationError[];

    public constructor(init?: Partial<FormValidationResult>) { (Object as any).assign(this, init); }
}

export class EventValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public eventId?: number;
    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public manageForms?: boolean;
    public redactable?: boolean;
    public errors: EventValidationError[];
    public formResults: FormValidationResult[];

    public constructor(init?: Partial<EventValidationResult>) { (Object as any).assign(this, init); }
}

export class PatientValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public patientId?: number;
    public patientDefinitionId?: number;
    public patientRepeat?: number;
    public errors: PatientValidationError[];
    public eventResults: EventValidationResult[];

    public constructor(init?: Partial<PatientValidationResult>) { (Object as any).assign(this, init); }
}

export class QueryValidationError implements IQueryValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<QueryValidationError>) { (Object as any).assign(this, init); }
}

export class QueryValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public queryId?: number;
    public errors: QueryValidationError[];

    public constructor(init?: Partial<QueryValidationResult>) { (Object as any).assign(this, init); }
}

export interface IDeleteResponse
{
}

export class EventState implements IEventState
{
    [immerable]? = true;

    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public manageForms?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<EventState>) { (Object as any).assign(this, init); }
}

export class FormState implements IFormState
{
    [immerable]? = true;

    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manage?: boolean;

    public constructor(init?: Partial<FormState>) { (Object as any).assign(this, init); }
}

export class BctUserPermissionContext
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public masterGroupId?: number;

    // @DataMember(Order=2)
    public masterGroupCode: string;

    // @DataMember(Order=3)
    public collaboratingGroupId?: number;

    // @DataMember(Order=4)
    public collaboratingGroupCode: string;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public institutionCode: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public patientStudyNumber: string;

    // @DataMember(Order=9)
    public permissions: Permission[];

    public constructor(init?: Partial<BctUserPermissionContext>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnel
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public email: string;

    public constructor(init?: Partial<InstitutionPersonnel>) { (Object as any).assign(this, init); }
}

export interface IFile extends IDataModel, IHasPatientId, IHasFormDefinitionId, IHasFormId, IFileUpload
{
    propertyName: string;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy: string;
    modifiedDate?: string;
    modifiedBy: string;
}

export interface IHasPatientId
{
    patientId?: number;
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormId
{
    formId?: number;
}

export interface IFileUpload
{
    extension: string;
    fileSize?: number;
    contentType: string;
    exists: boolean;
    image: boolean;
    upload: IFileUploadTemporary;
}

export interface IPatient extends IDataModel, IHasInstitutionId, IHasPatientStateId, IHasTreatmentId
{
    studyNumber: string;
}

export interface IHasInstitutionId
{
    institutionId?: number;
}

export interface IHasPatientStateId
{
    patientStateId?: number;
}

export interface IHasTreatmentId
{
    treatmentId?: number;
}

export interface IRegistrationPatient
{
    registrationNumber: string;
    registrationDate?: string;
}

export interface IEvent extends IDataModel, IHasPatientId, IHasEventDefinitionId
{
    repeat?: number;
}

export interface IHasEventDefinitionId
{
    eventDefinitionId?: number;
}

export interface IForm extends IDataModel, IHasPatientId, IHasEventId, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IHasEventId
{
    eventId?: number;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IHasFormStatus
{
    formStatus?: FormStatusType;
}

export interface ISubquery extends IDataModel
{
    queryId?: number;
    action?: QueryActionType;
    comments?: string;
}

export interface IQuery extends IDataModel
{
    formDefinitionId?: number;
    formId?: number;
    queryType?: QueryType;
    queryStatus?: QueryStatusType;
    title: string;
    propertyPath: string;
    subqueries: ISubquery[];
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName: string;
    label: string;
    detailedLabel: string;
    errorMessages: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel
{
    type?: FormType;
    name: string;
    code: string;
    instructions: string;
    patientInstructions: string;
    properties: IFormDefinitionProperty[];
    subformProperties: { [index:string]: IFormDefinitionProperty[]; };
}

export interface IConfigurationModel extends IModel
{
}

export interface IEventDefinitionFormDefinitionState extends IConfigurationModel, IHasEventDefinitionFormDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    manage?: boolean;
}

export interface IEventDefinitionFormDefinition extends IConfigurationModel, IHasEventDefinitionId, IHasFormDefinitionId
{
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    states: IEventDefinitionFormDefinitionState[];
}

export interface IEventDefinitionState extends IConfigurationModel, IHasEventDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    manageForms?: boolean;
}

export interface IEventDefinitionErrorMessage extends IConfigurationModel, IHasEventDefinitionId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IEventDefinition extends IConfigurationModel
{
    name: string;
    code: string;
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    formDefinitions: IEventDefinitionFormDefinition[];
    states: IEventDefinitionState[];
    errorMessages: IEventDefinitionErrorMessage[];
}

export interface IPatientState extends IConfigurationModel
{
    name: string;
    order?: number;
}

export interface ITreatment extends IConfigurationModel
{
    name: string;
}

export interface IValidationError
{
    message: string;
    detailedMessage: string;
    code: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    result: ValidationResultType;
    errors: IValidationError[];
}

export interface ILookupItem
{
    id?: number;
    value: string;
    order?: number;
    type?: number;
}

export interface ILookup
{
    propertyName: string;
    items: ILookupItem[];
}

export interface IMasterGroup extends IDataModel
{
    name: string;
    code: string;
}

export interface ICollaboratingGroup extends IDataModel, IHasMasterGroupId
{
    name: string;
    code: string;
}

export interface IHasMasterGroupId
{
    masterGroupId?: number;
}

export interface ICountry extends IDataModel
{
    name: string;
    code: string;
}

export interface IInstitution extends IDataModel, IHasMasterGroupId, IHasCollaboratingGroupId, IHasCountryId
{
    name: string;
    code: string;
    enabled?: boolean;
    activatedDate?: string;
    recruitmentDisabled?: boolean;
    eConsentActivationDate?: string;
}

export interface IHasCollaboratingGroupId
{
    collaboratingGroupId?: number;
}

export interface IHasCountryId
{
    countryId?: number;
}

export interface IPatientValidationError extends IValidationError
{
}

export interface IEventValidationError extends IValidationError
{
}

export interface IEventValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    eventDefinitionId?: number;
    eventId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    manageForms?: boolean;
    redactable?: boolean;
    errors: IEventValidationError[];
    formResults: IFormValidationResult[];
}

export interface IPatientValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    patientId?: number;
    errors: IPatientValidationError[];
    eventResults: IEventValidationResult[];
}

export interface IQueryValidationError extends IValidationError
{
    property: string;
}

export interface IQueryValidationResult extends IValidationResult
{
    queryId?: number;
    errors: IQueryValidationError[];
}

export interface IEventState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    manageForms?: boolean;
    redactable?: boolean;
}

export interface IFormState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    manage?: boolean;
    redactable?: boolean;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export interface IHasEventDefinitionFormDefinitionId
{
    eventDefinitionFormDefinitionId?: number;
}

export class CachedFormDefinitionCollectionResponse
{
    [immerable]? = true;

    public formDefinitions: FormDefinition[] = [];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedFormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedEventDefinitionCollectionResponse
{
    [immerable]? = true;

    public eventDefinitions: EventDefinition[] = [];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedEventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedPatientStateCollectionResponse
{
    [immerable]? = true;

    public patientStates: PatientState[] = [];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedPatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedTreatmentCollectionResponse
{
    [immerable]? = true;

    public treatments: Treatment[] = [];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedTreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable]? = true;

    public settings?: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class ActiveDirectoryResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ActiveDirectoryResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetPatientBaselineWeightResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public baselineWeight?: number;

    public constructor(init?: Partial<GetPatientBaselineWeightResponse>) { (Object as any).assign(this, init); }
}

export class SetPatientStatusResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SetPatientStatusResponse>) { (Object as any).assign(this, init); }
}

export class QueryGetSummariesByPatientIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: PatientQuerySummary[];

    public constructor(init?: Partial<QueryGetSummariesByPatientIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QuerySummariesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public data?: QuerySummary[];

    public constructor(init?: Partial<QuerySummariesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public roles?: string[];

    public constructor(init?: Partial<GetRolesResponse>) { (Object as any).assign(this, init); }
}

export class GetTpParticipantsByInstitutionIdResponse
{
    [immerable]? = true;

    public data: { [index:string]: string; } = {};
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpParticipantsByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormValidationByIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public result: IFormValidationResult;

    public constructor(init?: Partial<FormValidationByIdResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public upload: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public userId: string;
    public sessionId: string;
    public userName: string;
    public displayName: string;
    public type?: UserType;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public formMetadata: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event definition. */
    // @DataMember(Order=2)
    public eventDefinition: EventDefinition;

    public constructor(init?: Partial<EventDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event definitions. */
    // @DataMember(Order=2)
    public eventDefinitions: EventDefinition[];

    public constructor(init?: Partial<EventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public formDefinition: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public formDefinitions: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient state. */
    // @DataMember(Order=2)
    public patientState: PatientState;

    public constructor(init?: Partial<PatientStateSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient states. */
    // @DataMember(Order=2)
    public patientStates: PatientState[];

    public constructor(init?: Partial<PatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatment. */
    // @DataMember(Order=2)
    public treatment: Treatment;

    public constructor(init?: Partial<TreatmentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatments. */
    // @DataMember(Order=2)
    public treatments: Treatment[];

    public constructor(init?: Partial<TreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved master group. */
    // @DataMember(Order=2)
    public masterGroup: MasterGroup;

    public constructor(init?: Partial<MasterGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved master groups. */
    // @DataMember(Order=2)
    public masterGroups: MasterGroup[];

    public constructor(init?: Partial<MasterGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved collaborating group. */
    // @DataMember(Order=2)
    public collaboratingGroup: CollaboratingGroup;

    public constructor(init?: Partial<CollaboratingGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved collaborating groups. */
    // @DataMember(Order=2)
    public collaboratingGroups: CollaboratingGroup[];

    public constructor(init?: Partial<CollaboratingGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountrySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved country. */
    // @DataMember(Order=2)
    public country: Country;

    public constructor(init?: Partial<CountrySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved countrys. */
    // @DataMember(Order=2)
    public countries: Country[];

    public constructor(init?: Partial<CountryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved institution. */
    // @DataMember(Order=2)
    public institution: Institution;

    public constructor(init?: Partial<InstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved institutions. */
    // @DataMember(Order=2)
    public institutions: Institution[];

    public constructor(init?: Partial<InstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient. */
    // @DataMember(Order=2)
    public patient: Patient;

    public constructor(init?: Partial<PatientSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: PatientValidationResult;

    public constructor(init?: Partial<PatientValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patients. */
    // @DataMember(Order=2)
    public patients: Patient[];

    public constructor(init?: Partial<PatientCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: EventValidationResult;

    public constructor(init?: Partial<EventValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event. */
    // @DataMember(Order=2)
    public event: Event;

    public constructor(init?: Partial<EventSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved events. */
    // @DataMember(Order=2)
    public events: Event[];

    public constructor(init?: Partial<EventCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved adverse event form. */
    // @DataMember(Order=2)
    public form: AdverseEventForm;

    public constructor(init?: Partial<AdverseEventFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved adverse event forms. */
    // @DataMember(Order=2)
    public forms: AdverseEventForm[];

    public constructor(init?: Partial<AdverseEventFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdverseEventFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<AdverseEventFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdverseEventFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventsFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved adverse events form. */
    // @DataMember(Order=2)
    public form: AdverseEventsForm;

    public constructor(init?: Partial<AdverseEventsFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventsFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved adverse events forms. */
    // @DataMember(Order=2)
    public forms: AdverseEventsForm[];

    public constructor(init?: Partial<AdverseEventsFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventsFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdverseEventsFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventsFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<AdverseEventsFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventsFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdverseEventsFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BaselineDemographicsFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved baseline demographics form. */
    // @DataMember(Order=2)
    public form: BaselineDemographicsForm;

    public constructor(init?: Partial<BaselineDemographicsFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BaselineDemographicsFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved baseline demographics forms. */
    // @DataMember(Order=2)
    public forms: BaselineDemographicsForm[];

    public constructor(init?: Partial<BaselineDemographicsFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BaselineDemographicsFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BaselineDemographicsFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BaselineDemographicsFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<BaselineDemographicsFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BaselineDemographicsFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BaselineDemographicsFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BloodCollectionFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved blood collection form. */
    // @DataMember(Order=2)
    public form: BloodCollectionForm;

    public constructor(init?: Partial<BloodCollectionFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BloodCollectionFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved blood collection forms. */
    // @DataMember(Order=2)
    public forms: BloodCollectionForm[];

    public constructor(init?: Partial<BloodCollectionFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BloodCollectionFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BloodCollectionFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BloodCollectionFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<BloodCollectionFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BloodCollectionFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BloodCollectionFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndOfTreatmentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved end of treatment form. */
    // @DataMember(Order=2)
    public form: EndOfTreatmentForm;

    public constructor(init?: Partial<EndOfTreatmentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndOfTreatmentFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved end of treatment forms. */
    // @DataMember(Order=2)
    public forms: EndOfTreatmentForm[];

    public constructor(init?: Partial<EndOfTreatmentFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndOfTreatmentFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<EndOfTreatmentFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndOfTreatmentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<EndOfTreatmentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndOfTreatmentFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<EndOfTreatmentFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved registration form. */
    // @DataMember(Order=2)
    public form: RegistrationForm;

    public constructor(init?: Partial<RegistrationFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved registration forms. */
    // @DataMember(Order=2)
    public forms: RegistrationForm[];

    public constructor(init?: Partial<RegistrationFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegistrationFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<RegistrationFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegistrationFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class VisitDetailsFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved visit details form. */
    // @DataMember(Order=2)
    public form: VisitDetailsForm;

    public constructor(init?: Partial<VisitDetailsFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class VisitDetailsFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved visit details forms. */
    // @DataMember(Order=2)
    public forms: VisitDetailsForm[];

    public constructor(init?: Partial<VisitDetailsFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class VisitDetailsFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VisitDetailsFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class VisitDetailsFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<VisitDetailsFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class VisitDetailsFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VisitDetailsFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved withdrawal form. */
    // @DataMember(Order=2)
    public form: WithdrawalForm;

    public constructor(init?: Partial<WithdrawalFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved withdrawal forms. */
    // @DataMember(Order=2)
    public forms: WithdrawalForm[];

    public constructor(init?: Partial<WithdrawalFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<WithdrawalFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<WithdrawalFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<WithdrawalFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QuerySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved query. */
    // @DataMember(Order=2)
    public query: Query;

    public constructor(init?: Partial<QuerySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved querys. */
    // @DataMember(Order=2)
    public queries: Query[];

    public constructor(init?: Partial<QueryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: QueryValidationResult;

    public constructor(init?: Partial<QueryValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryDeleteResponse implements IDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueryDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SubqueryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved subquerys. */
    // @DataMember(Order=2)
    public subqueries: Subquery[];

    public constructor(init?: Partial<SubqueryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SubquerySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved subquery. */
    // @DataMember(Order=2)
    public subquery: Subquery;

    public constructor(init?: Partial<SubquerySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventStateResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event states for the patient. */
    // @DataMember(Order=2)
    public states: EventState[];

    public constructor(init?: Partial<EventStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormStateResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form states for the patient event. */
    // @DataMember(Order=2)
    public states: FormState[];

    public constructor(init?: Partial<FormStateResponse>) { (Object as any).assign(this, init); }
}

export class UserPermissionsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public permissions: BctUserPermissionContext[];

    public constructor(init?: Partial<UserPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class HasOpmsPermissionCollectionResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public hasPermission: { [index:number]: boolean; };

    public constructor(init?: Partial<HasOpmsPermissionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelEmailAddressesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public emailAddresses: MailAddress[];

    public constructor(init?: Partial<InstitutionPersonnelEmailAddressesResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public personnel: { [index:number]: InstitutionPersonnel; };

    public constructor(init?: Partial<InstitutionPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelNamesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public personnelNames: { [index:number]: string; };

    public constructor(init?: Partial<InstitutionPersonnelNamesResponse>) { (Object as any).assign(this, init); }
}

export class TrialPersonnelActiveRoleResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public hasRole: { [index:number]: boolean; };

    public constructor(init?: Partial<TrialPersonnelActiveRoleResponse>) { (Object as any).assign(this, init); }
}

export class UserPersonnelEmailAddressResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public emailAddress: MailAddress;

    public constructor(init?: Partial<UserPersonnelEmailAddressResponse>) { (Object as any).assign(this, init); }
}

export class GetCachedFormDefinitions implements IReturn<CachedFormDefinitionCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedFormDefinitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedFormDefinitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedFormDefinitionCollectionResponse(); }
}

export class GetCachedEventDefinitions implements IReturn<CachedEventDefinitionCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedEventDefinitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedEventDefinitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedEventDefinitionCollectionResponse(); }
}

export class GetCachedPatientStates implements IReturn<CachedPatientStateCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedPatientStates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedPatientStates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedPatientStateCollectionResponse(); }
}

export class GetCachedTreatments implements IReturn<CachedTreatmentCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedTreatments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedTreatments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedTreatmentCollectionResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @Route("/locales/{LocaleCode}/{NamespaceCode}", "GET")
export class GetLocaleNamespace implements IReturn<Object>, IGet
{
    [immerable]? = true;

    public localeCode?: string;
    public namespaceCode?: string;

    public constructor(init?: Partial<GetLocaleNamespace>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocaleNamespace'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}

// @Route("/locales/{LocaleCode}/{NamespaceCode}/add", "POST")
export class AddLocaleNamespaceTranslation implements IReturn<Object>, IPost
{
    [immerable]? = true;

    public localeCode?: string;
    public namespaceCode?: string;
    public requestStream: string;

    public constructor(init?: Partial<AddLocaleNamespaceTranslation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLocaleNamespaceTranslation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}

export class GetLocales implements IReturn<Locale[]>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetLocales>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocales'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Locale>(); }
}

export class GetNamespaces implements IReturn<Namespace[]>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetNamespaces>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNamespaces'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Namespace>(); }
}

export class GetTranslations implements IReturn<Translation[]>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetTranslations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTranslations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Translation>(); }
}

export class SaveTranslation implements IReturn<boolean>
{
    [immerable]? = true;

    public translation?: Translation;

    public constructor(init?: Partial<SaveTranslation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTranslation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}

export class DummyRequest implements IReturnVoid
{
    [immerable]? = true;

    public patientStateType: PatientStateType;
    public eventDefinitionType: EventDefinitionType;
    public lookupEthnicityType: LookupEthnicityType;
    public lookupNoYesType: LookupNoYesType;
    public lookupKnownUnknownType: LookupKnownUnknownType;
    public lookupYesNoUnknownType: LookupYesNoUnknownType;
    public lookupEotReasonType: LookupEotReasonType;
    public lookupNumberDoseReductionsType: LookupNumberDoseReductionsType;
    public lookupSexType: LookupSexType;
    public lookupIneligibleReasonType: LookupIneligibleReasonType;
    public lookupGenderType: LookupGenderType;
    public file?: File;

    public constructor(init?: Partial<DummyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DummyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class PatientAccountCreate implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public email: string;
    public password: string;

    public constructor(init?: Partial<PatientAccountCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class PatientAccountResendWelcome implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<PatientAccountResendWelcome>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountResendWelcome'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class PatientAccountSetPassword implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public password: string;

    public constructor(init?: Partial<PatientAccountSetPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountSetPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class PatientAccountUpdateEmail implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public email: string;

    public constructor(init?: Partial<PatientAccountUpdateEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountUpdateEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

// @DataContract
export class GetPatientBaselineWeight implements IReturn<GetPatientBaselineWeightResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<GetPatientBaselineWeight>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientBaselineWeight'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientBaselineWeightResponse(); }
}

// @DataContract
export class SetPatientStatus implements IReturn<SetPatientStatusResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public patientStateId?: number;

    // @DataMember(Order=3)
    public notes?: string;

    public constructor(init?: Partial<SetPatientStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPatientStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPatientStatusResponse(); }
}

// @DataContract
export class QueryGetSummariesByPatientId implements IReturn<QueryGetSummariesByPatientIdResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    public constructor(init?: Partial<QueryGetSummariesByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetSummariesByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryGetSummariesByPatientIdResponse(); }
}

// @DataContract
export class QueryGetSummaries implements IReturn<QuerySummariesResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<QueryGetSummaries>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetSummaries'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySummariesResponse(); }
}

// @DataContract
export class GetRoles implements IReturn<GetRolesResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRoles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRolesResponse(); }
}

// @Route("/get/tp-participants/", "GET")
// @Route("/get/tp-participants/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpParticipantsByInstitutionId implements IReturn<GetTpParticipantsByInstitutionIdResponse>
{
    [immerable]? = true;

    public institutionId?: number;

    public constructor(init?: Partial<GetTpParticipantsByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpParticipantsByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpParticipantsByInstitutionIdResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable]? = true;

    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @DataContract
export class FormValidationById implements IReturn<FormValidationByIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    // @DataMember(Order=3)
    public eventRepeat?: number;

    // @DataMember(Order=4)
    public formDefinitionId?: number;

    // @DataMember(Order=5)
    public formRepeat?: number;

    public constructor(init?: Partial<FormValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormValidationById'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FormValidationByIdResponse(); }
}

// @Route("/opms/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable]? = true;


    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/user")
export class GetUser implements IReturn<GetUserResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

// @Route("/opms/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable]? = true;

    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/opms/form-names")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/opms/event-definition/single/id/{Id}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleById implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/single/code/{Code}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleByCode implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<EventDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/collection", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetCollection implements IReturn<EventDefinitionCollectionResponse>, IEventDefinitionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EventDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionCollectionResponse(); }
}

// @Route("/opms/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IFormDefinitionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/opms/patient-state/single/id/{Id}", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetSingleById implements IReturn<PatientStateSingleResponse>, IPatientStateGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient state to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientStateGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateSingleResponse(); }
}

// @Route("/opms/patient-state/collection", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetCollection implements IReturn<PatientStateCollectionResponse>, IPatientStateGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PatientStateGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateCollectionResponse(); }
}

// @Route("/opms/treatment/single/id/{Id}", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetSingleById implements IReturn<TreatmentSingleResponse>, ITreatmentGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the treatment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TreatmentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentSingleResponse(); }
}

// @Route("/opms/treatment/collection", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetCollection implements IReturn<TreatmentCollectionResponse>, ITreatmentGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TreatmentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentCollectionResponse(); }
}

// @Route("/opms/master-group/single/id/{Id}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleById implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MasterGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/single/code/{Code}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleByCode implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<MasterGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/collection", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollection implements IReturn<MasterGroupCollectionResponse>, IMasterGroupGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MasterGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/single/id/{Id}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleById implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CollaboratingGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/single/code/{Code}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleByCode implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<CollaboratingGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/collection", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollection implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CollaboratingGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupId implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupCode implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/country/single/id/{Id}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleById implements IReturn<CountrySingleResponse>, ICountryGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CountryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/single/code/{Code}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleByCode implements IReturn<CountrySingleResponse>, ICountryGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<CountryGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/collection", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollection implements IReturn<CountryCollectionResponse>, ICountryGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CountryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/institution/single/id/{Id}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleById implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/single/code/{Code}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleByCode implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<InstitutionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/collection", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollection implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<InstitutionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/id/{CountryId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryId
{
    [immerable]? = true;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryCode
{
    [immerable]? = true;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/patient/single/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleById implements IReturn<PatientSingleResponse>, IPatientGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/single/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleByStudyNumber implements IReturn<PatientSingleResponse>, IPatientGetSingleByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<PatientGetSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/validation/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationById implements IReturn<PatientValidationResponse>, IPatientGetValidationById
{
    [immerable]? = true;

    /** @description The ID of the patient to validate. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description Whether to only run the patient validator or to validate all events and forms as well. */
    // @DataMember(Order=2)
    public patientOnly?: boolean;

    public constructor(init?: Partial<PatientGetValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/validation/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationByStudyNumber implements IReturn<PatientValidationResponse>, IPatientGetValidationByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to validate. */
    // @DataMember(Order=1)
    public studyNumber: string;

    /** @description Whether to only run the patient validator or to validate all events and forms as well. */
    // @DataMember(Order=2)
    public patientOnly?: boolean;

    public constructor(init?: Partial<PatientGetValidationByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/collection", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollection implements IReturn<PatientCollectionResponse>, IPatientGetCollection
{
    [immerable]? = true;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/id/{CountryId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryId
{
    [immerable]? = true;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/id/{InstitutionId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionId
{
    [immerable]? = true;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryCode
{
    [immerable]? = true;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/code/{InstitutionCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The Code of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/Save", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSave implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    public constructor(init?: Partial<PatientPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/ids", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithIds implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    public constructor(init?: Partial<PatientPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/codes", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithCodes implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    public constructor(init?: Partial<PatientPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/event/validation/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=500)
// @DataContract
export class EventGetValidationByIds implements IReturn<EventValidationResponse>, IEventGetValidationByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the event to validate. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to validate. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the event to validate. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description Whether to only run the event validator or to validate all forms as well. */
    // @DataMember(Order=4)
    public eventOnly?: boolean;

    public constructor(init?: Partial<EventGetValidationByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetValidationByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventValidationResponse(); }
}

// @Route("/opms/event/single/id/{Id}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleById implements IReturn<EventSingleResponse>, IEventGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the event to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/ids", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByIds implements IReturn<EventSingleResponse>, IEventGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Id of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/codes", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByCodes implements IReturn<EventSingleResponse>, IEventGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Code of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/collection", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollection implements IReturn<EventCollectionResponse>, IEventGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EventGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/id/{PatientId}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientId implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientId
{
    [immerable]? = true;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientId: number;

    public constructor(init?: Partial<EventGetCollectionByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/study-number/{PatientStudyNumber}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientStudyNumber implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    public constructor(init?: Partial<EventGetCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/Save", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSave implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    public constructor(init?: Partial<EventPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/ids", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithIds implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The ID of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/codes", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithCodes implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The Code of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/single/id/{Id}", "GET")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormGetSingleById implements IReturn<AdverseEventFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdverseEventFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventFormSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/single/ids", "GET")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormGetSingleByIds implements IReturn<AdverseEventFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the adverse event form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new adverse event form if no adverse event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdverseEventFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventFormSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/single/codes", "GET")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormGetSingleByCodes implements IReturn<AdverseEventFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the adverse event form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new adverse event form if no adverse event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdverseEventFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventFormSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/collection", "GET")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormGetCollection implements IReturn<AdverseEventFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<AdverseEventFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventFormCollectionResponse(); }
}

// @Route("/opms/form/adverse-event-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormGetCollectionByIds implements IReturn<AdverseEventFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventFormCollectionResponse(); }
}

// @Route("/opms/form/adverse-event-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormGetCollectionByCodes implements IReturn<AdverseEventFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventFormCollectionResponse(); }
}

// @Route("/opms/form/adverse-event-form/save", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostSave implements IReturn<AdverseEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to save. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    public constructor(init?: Partial<AdverseEventFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/save/ids", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostSaveWithIds implements IReturn<AdverseEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to save. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    /** @description The ID of the Institution associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the adverse event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdverseEventFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/save/codes", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostSaveWithCodes implements IReturn<AdverseEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to save. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    /** @description The Code of the Institution associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the adverse event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdverseEventFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormSingleResponse(); }
}

// @Route("/opms/form/adverse-event-form/delete", "DELETE")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormDelete implements IReturn<AdverseEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to delete. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    public constructor(init?: Partial<AdverseEventFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-event-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormDeleteWithId implements IReturn<AdverseEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdverseEventFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-event-form/delete/ids", "DELETE")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormDeleteWithIds implements IReturn<AdverseEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdverseEventFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-event-form/delete/codes", "DELETE")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormDeleteByCodes implements IReturn<AdverseEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the adverse event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdverseEventFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-event-form/validate", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostValidate implements IReturn<AdverseEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to validate. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    public constructor(init?: Partial<AdverseEventFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormValidationResponse(); }
}

// @Route("/opms/form/adverse-event-form/validate/ids", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostValidateWithIds implements IReturn<AdverseEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to validate. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    /** @description The ID of the Institution associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormValidationResponse(); }
}

// @Route("/opms/form/adverse-event-form/validate/codes", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostValidateWithCodes implements IReturn<AdverseEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse event form to validate. */
    // @DataMember(Order=1)
    public form: AdverseEventForm;

    /** @description The Code of the Institution associated with the adverse event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the adverse event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the adverse event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormValidationResponse(); }
}

// @Route("/opms/form/adverse-event-form/update-status/", "POST")
// @Api(Description="Form - Adverse Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class AdverseEventFormPostUpdateStatusByIds implements IReturn<AdverseEventFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the adverse event form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the adverse event form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the adverse event form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the adverse event form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the adverse event form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<AdverseEventFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventFormUpdateStatusResponse(); }
}

// @Route("/opms/form/adverse-events-form/single/id/{Id}", "GET")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormGetSingleById implements IReturn<AdverseEventsFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdverseEventsFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventsFormSingleResponse(); }
}

// @Route("/opms/form/adverse-events-form/single/ids", "GET")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormGetSingleByIds implements IReturn<AdverseEventsFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the adverse events form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new adverse events form if no adverse events form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdverseEventsFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventsFormSingleResponse(); }
}

// @Route("/opms/form/adverse-events-form/single/codes", "GET")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormGetSingleByCodes implements IReturn<AdverseEventsFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the adverse events form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new adverse events form if no adverse events form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdverseEventsFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventsFormSingleResponse(); }
}

// @Route("/opms/form/adverse-events-form/collection", "GET")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormGetCollection implements IReturn<AdverseEventsFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<AdverseEventsFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventsFormCollectionResponse(); }
}

// @Route("/opms/form/adverse-events-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormGetCollectionByIds implements IReturn<AdverseEventsFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventsFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventsFormCollectionResponse(); }
}

// @Route("/opms/form/adverse-events-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormGetCollectionByCodes implements IReturn<AdverseEventsFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventsFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventsFormCollectionResponse(); }
}

// @Route("/opms/form/adverse-events-form/save", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostSave implements IReturn<AdverseEventsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to save. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    public constructor(init?: Partial<AdverseEventsFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormSingleResponse(); }
}

// @Route("/opms/form/adverse-events-form/save/ids", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostSaveWithIds implements IReturn<AdverseEventsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to save. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    /** @description The ID of the Institution associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the adverse events form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdverseEventsFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormSingleResponse(); }
}

// @Route("/opms/form/adverse-events-form/save/codes", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostSaveWithCodes implements IReturn<AdverseEventsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to save. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    /** @description The Code of the Institution associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the adverse events form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdverseEventsFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormSingleResponse(); }
}

// @Route("/opms/form/adverse-events-form/delete", "DELETE")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormDelete implements IReturn<AdverseEventsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to delete. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    public constructor(init?: Partial<AdverseEventsFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventsFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-events-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormDeleteWithId implements IReturn<AdverseEventsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdverseEventsFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventsFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-events-form/delete/ids", "DELETE")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormDeleteWithIds implements IReturn<AdverseEventsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdverseEventsFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventsFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-events-form/delete/codes", "DELETE")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormDeleteByCodes implements IReturn<AdverseEventsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the adverse events form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdverseEventsFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventsFormDeleteResponse(); }
}

// @Route("/opms/form/adverse-events-form/validate", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostValidate implements IReturn<AdverseEventsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to validate. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    public constructor(init?: Partial<AdverseEventsFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormValidationResponse(); }
}

// @Route("/opms/form/adverse-events-form/validate/ids", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostValidateWithIds implements IReturn<AdverseEventsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to validate. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    /** @description The ID of the Institution associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventsFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormValidationResponse(); }
}

// @Route("/opms/form/adverse-events-form/validate/codes", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostValidateWithCodes implements IReturn<AdverseEventsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse events form to validate. */
    // @DataMember(Order=1)
    public form: AdverseEventsForm;

    /** @description The Code of the Institution associated with the adverse events form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the adverse events form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the adverse events form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse events form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventsFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormValidationResponse(); }
}

// @Route("/opms/form/adverse-events-form/update-status/", "POST")
// @Api(Description="Form - Adverse Events Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventsFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventsFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventsFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventsFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventsFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class AdverseEventsFormPostUpdateStatusByIds implements IReturn<AdverseEventsFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the adverse events form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the adverse events form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the adverse events form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the adverse events form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the adverse events form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<AdverseEventsFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventsFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventsFormUpdateStatusResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/single/id/{Id}", "GET")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormGetSingleById implements IReturn<BaselineDemographicsFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BaselineDemographicsFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaselineDemographicsFormSingleResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/single/ids", "GET")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormGetSingleByIds implements IReturn<BaselineDemographicsFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the baseline demographics form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new baseline demographics form if no baseline demographics form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BaselineDemographicsFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaselineDemographicsFormSingleResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/single/codes", "GET")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormGetSingleByCodes implements IReturn<BaselineDemographicsFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the baseline demographics form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new baseline demographics form if no baseline demographics form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BaselineDemographicsFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaselineDemographicsFormSingleResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/collection", "GET")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormGetCollection implements IReturn<BaselineDemographicsFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<BaselineDemographicsFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaselineDemographicsFormCollectionResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormGetCollectionByIds implements IReturn<BaselineDemographicsFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BaselineDemographicsFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaselineDemographicsFormCollectionResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormGetCollectionByCodes implements IReturn<BaselineDemographicsFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BaselineDemographicsFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BaselineDemographicsFormCollectionResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/save", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostSave implements IReturn<BaselineDemographicsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to save. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    public constructor(init?: Partial<BaselineDemographicsFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormSingleResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/save/ids", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostSaveWithIds implements IReturn<BaselineDemographicsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to save. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    /** @description The ID of the Institution associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the baseline demographics form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BaselineDemographicsFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormSingleResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/save/codes", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormSingleResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostSaveWithCodes implements IReturn<BaselineDemographicsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to save. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    /** @description The Code of the Institution associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the baseline demographics form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BaselineDemographicsFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormSingleResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/delete", "DELETE")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormDelete implements IReturn<BaselineDemographicsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to delete. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    public constructor(init?: Partial<BaselineDemographicsFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BaselineDemographicsFormDeleteResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormDeleteWithId implements IReturn<BaselineDemographicsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BaselineDemographicsFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BaselineDemographicsFormDeleteResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/delete/ids", "DELETE")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormDeleteWithIds implements IReturn<BaselineDemographicsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BaselineDemographicsFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BaselineDemographicsFormDeleteResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/delete/codes", "DELETE")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormDeleteByCodes implements IReturn<BaselineDemographicsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the baseline demographics form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BaselineDemographicsFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BaselineDemographicsFormDeleteResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/validate", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostValidate implements IReturn<BaselineDemographicsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to validate. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    public constructor(init?: Partial<BaselineDemographicsFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormValidationResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/validate/ids", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostValidateWithIds implements IReturn<BaselineDemographicsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to validate. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    /** @description The ID of the Institution associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BaselineDemographicsFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormValidationResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/validate/codes", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormValidationResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostValidateWithCodes implements IReturn<BaselineDemographicsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The baseline demographics form to validate. */
    // @DataMember(Order=1)
    public form: BaselineDemographicsForm;

    /** @description The Code of the Institution associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the baseline demographics form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BaselineDemographicsFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormValidationResponse(); }
}

// @Route("/opms/form/baseline-demographics-form/update-status/", "POST")
// @Api(Description="Form - Baseline Demographics Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BaselineDemographicsFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class BaselineDemographicsFormPostUpdateStatusByIds implements IReturn<BaselineDemographicsFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the baseline demographics form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the baseline demographics form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the baseline demographics form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the baseline demographics form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the baseline demographics form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<BaselineDemographicsFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BaselineDemographicsFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BaselineDemographicsFormUpdateStatusResponse(); }
}

// @Route("/opms/form/blood-collection-form/single/id/{Id}", "GET")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormGetSingleById implements IReturn<BloodCollectionFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BloodCollectionFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BloodCollectionFormSingleResponse(); }
}

// @Route("/opms/form/blood-collection-form/single/ids", "GET")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormGetSingleByIds implements IReturn<BloodCollectionFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the blood collection form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new blood collection form if no blood collection form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BloodCollectionFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BloodCollectionFormSingleResponse(); }
}

// @Route("/opms/form/blood-collection-form/single/codes", "GET")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormGetSingleByCodes implements IReturn<BloodCollectionFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the blood collection form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new blood collection form if no blood collection form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BloodCollectionFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BloodCollectionFormSingleResponse(); }
}

// @Route("/opms/form/blood-collection-form/collection", "GET")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormGetCollection implements IReturn<BloodCollectionFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<BloodCollectionFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BloodCollectionFormCollectionResponse(); }
}

// @Route("/opms/form/blood-collection-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormGetCollectionByIds implements IReturn<BloodCollectionFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BloodCollectionFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BloodCollectionFormCollectionResponse(); }
}

// @Route("/opms/form/blood-collection-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormCollectionResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormGetCollectionByCodes implements IReturn<BloodCollectionFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BloodCollectionFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BloodCollectionFormCollectionResponse(); }
}

// @Route("/opms/form/blood-collection-form/save", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostSave implements IReturn<BloodCollectionFormSingleResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to save. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    public constructor(init?: Partial<BloodCollectionFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormSingleResponse(); }
}

// @Route("/opms/form/blood-collection-form/save/ids", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostSaveWithIds implements IReturn<BloodCollectionFormSingleResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to save. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    /** @description The ID of the Institution associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the blood collection form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BloodCollectionFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormSingleResponse(); }
}

// @Route("/opms/form/blood-collection-form/save/codes", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormSingleResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostSaveWithCodes implements IReturn<BloodCollectionFormSingleResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to save. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    /** @description The Code of the Institution associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the blood collection form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BloodCollectionFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormSingleResponse(); }
}

// @Route("/opms/form/blood-collection-form/delete", "DELETE")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormDelete implements IReturn<BloodCollectionFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to delete. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    public constructor(init?: Partial<BloodCollectionFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BloodCollectionFormDeleteResponse(); }
}

// @Route("/opms/form/blood-collection-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormDeleteWithId implements IReturn<BloodCollectionFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BloodCollectionFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BloodCollectionFormDeleteResponse(); }
}

// @Route("/opms/form/blood-collection-form/delete/ids", "DELETE")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormDeleteWithIds implements IReturn<BloodCollectionFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BloodCollectionFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BloodCollectionFormDeleteResponse(); }
}

// @Route("/opms/form/blood-collection-form/delete/codes", "DELETE")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormDeleteResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormDeleteByCodes implements IReturn<BloodCollectionFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the blood collection form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BloodCollectionFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BloodCollectionFormDeleteResponse(); }
}

// @Route("/opms/form/blood-collection-form/validate", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostValidate implements IReturn<BloodCollectionFormValidationResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to validate. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    public constructor(init?: Partial<BloodCollectionFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormValidationResponse(); }
}

// @Route("/opms/form/blood-collection-form/validate/ids", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostValidateWithIds implements IReturn<BloodCollectionFormValidationResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to validate. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    /** @description The ID of the Institution associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BloodCollectionFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormValidationResponse(); }
}

// @Route("/opms/form/blood-collection-form/validate/codes", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormValidationResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostValidateWithCodes implements IReturn<BloodCollectionFormValidationResponse>
{
    [immerable]? = true;

    /** @description The blood collection form to validate. */
    // @DataMember(Order=1)
    public form: BloodCollectionForm;

    /** @description The Code of the Institution associated with the blood collection form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the blood collection form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the blood collection form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the blood collection form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BloodCollectionFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormValidationResponse(); }
}

// @Route("/opms/form/blood-collection-form/update-status/", "POST")
// @Api(Description="Form - Blood Collection Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BloodCollectionFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BloodCollectionFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BloodCollectionFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BloodCollectionFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BloodCollectionFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class BloodCollectionFormPostUpdateStatusByIds implements IReturn<BloodCollectionFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the blood collection form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the blood collection form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the blood collection form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the blood collection form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the blood collection form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<BloodCollectionFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BloodCollectionFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BloodCollectionFormUpdateStatusResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/single/id/{Id}", "GET")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormGetSingleById implements IReturn<EndOfTreatmentFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EndOfTreatmentFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndOfTreatmentFormSingleResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/single/ids", "GET")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormGetSingleByIds implements IReturn<EndOfTreatmentFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the end of treatment form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new end of treatment form if no end of treatment form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EndOfTreatmentFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndOfTreatmentFormSingleResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/single/codes", "GET")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormGetSingleByCodes implements IReturn<EndOfTreatmentFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the end of treatment form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new end of treatment form if no end of treatment form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EndOfTreatmentFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndOfTreatmentFormSingleResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/collection", "GET")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormGetCollection implements IReturn<EndOfTreatmentFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EndOfTreatmentFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndOfTreatmentFormCollectionResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormGetCollectionByIds implements IReturn<EndOfTreatmentFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndOfTreatmentFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndOfTreatmentFormCollectionResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormGetCollectionByCodes implements IReturn<EndOfTreatmentFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndOfTreatmentFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndOfTreatmentFormCollectionResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/save", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostSave implements IReturn<EndOfTreatmentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to save. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    public constructor(init?: Partial<EndOfTreatmentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormSingleResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/save/ids", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostSaveWithIds implements IReturn<EndOfTreatmentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to save. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    /** @description The ID of the Institution associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the end of treatment form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EndOfTreatmentFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormSingleResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/save/codes", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormSingleResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostSaveWithCodes implements IReturn<EndOfTreatmentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to save. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    /** @description The Code of the Institution associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the end of treatment form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EndOfTreatmentFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormSingleResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/delete", "DELETE")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormDelete implements IReturn<EndOfTreatmentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to delete. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    public constructor(init?: Partial<EndOfTreatmentFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndOfTreatmentFormDeleteResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormDeleteWithId implements IReturn<EndOfTreatmentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EndOfTreatmentFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndOfTreatmentFormDeleteResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/delete/ids", "DELETE")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormDeleteWithIds implements IReturn<EndOfTreatmentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EndOfTreatmentFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndOfTreatmentFormDeleteResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/delete/codes", "DELETE")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormDeleteByCodes implements IReturn<EndOfTreatmentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the end of treatment form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EndOfTreatmentFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndOfTreatmentFormDeleteResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/validate", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostValidate implements IReturn<EndOfTreatmentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to validate. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    public constructor(init?: Partial<EndOfTreatmentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormValidationResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/validate/ids", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostValidateWithIds implements IReturn<EndOfTreatmentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to validate. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    /** @description The ID of the Institution associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndOfTreatmentFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormValidationResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/validate/codes", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormValidationResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostValidateWithCodes implements IReturn<EndOfTreatmentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The end of treatment form to validate. */
    // @DataMember(Order=1)
    public form: EndOfTreatmentForm;

    /** @description The Code of the Institution associated with the end of treatment form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the end of treatment form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the end of treatment form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the end of treatment form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndOfTreatmentFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormValidationResponse(); }
}

// @Route("/opms/form/end-of-treatment-form/update-status/", "POST")
// @Api(Description="Form - End Of Treatment Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndOfTreatmentFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class EndOfTreatmentFormPostUpdateStatusByIds implements IReturn<EndOfTreatmentFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the end of treatment form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the end of treatment form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the end of treatment form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the end of treatment form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the end of treatment form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<EndOfTreatmentFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndOfTreatmentFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndOfTreatmentFormUpdateStatusResponse(); }
}

// @Route("/opms/form/registration-form/single/id/{Id}", "GET")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormGetSingleById implements IReturn<RegistrationFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the registration form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationFormSingleResponse(); }
}

// @Route("/opms/form/registration-form/single/ids", "GET")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormGetSingleByIds implements IReturn<RegistrationFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the registration form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the registration form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new registration form if no registration form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RegistrationFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationFormSingleResponse(); }
}

// @Route("/opms/form/registration-form/single/codes", "GET")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormGetSingleByCodes implements IReturn<RegistrationFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the registration form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the registration form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new registration form if no registration form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RegistrationFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationFormSingleResponse(); }
}

// @Route("/opms/form/registration-form/collection", "GET")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormGetCollection implements IReturn<RegistrationFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<RegistrationFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationFormCollectionResponse(); }
}

// @Route("/opms/form/registration-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormGetCollectionByIds implements IReturn<RegistrationFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the registration form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationFormCollectionResponse(); }
}

// @Route("/opms/form/registration-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormGetCollectionByCodes implements IReturn<RegistrationFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the registration form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationFormCollectionResponse(); }
}

// @Route("/opms/form/registration-form/save", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostSave implements IReturn<RegistrationFormSingleResponse>
{
    [immerable]? = true;

    /** @description The registration form to save. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    public constructor(init?: Partial<RegistrationFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormSingleResponse(); }
}

// @Route("/opms/form/registration-form/save/ids", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostSaveWithIds implements IReturn<RegistrationFormSingleResponse>
{
    [immerable]? = true;

    /** @description The registration form to save. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    /** @description The ID of the Institution associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the registration form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RegistrationFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormSingleResponse(); }
}

// @Route("/opms/form/registration-form/save/codes", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostSaveWithCodes implements IReturn<RegistrationFormSingleResponse>
{
    [immerable]? = true;

    /** @description The registration form to save. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    /** @description The Code of the Institution associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the registration form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the registration form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RegistrationFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormSingleResponse(); }
}

// @Route("/opms/form/registration-form/delete", "DELETE")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormDelete implements IReturn<RegistrationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The registration form to delete. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    public constructor(init?: Partial<RegistrationFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationFormDeleteResponse(); }
}

// @Route("/opms/form/registration-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormDeleteWithId implements IReturn<RegistrationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the registration form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationFormDeleteResponse(); }
}

// @Route("/opms/form/registration-form/delete/ids", "DELETE")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormDeleteWithIds implements IReturn<RegistrationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the registration form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RegistrationFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationFormDeleteResponse(); }
}

// @Route("/opms/form/registration-form/delete/codes", "DELETE")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormDeleteByCodes implements IReturn<RegistrationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the registration form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RegistrationFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationFormDeleteResponse(); }
}

// @Route("/opms/form/registration-form/validate", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostValidate implements IReturn<RegistrationFormValidationResponse>
{
    [immerable]? = true;

    /** @description The registration form to validate. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    public constructor(init?: Partial<RegistrationFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormValidationResponse(); }
}

// @Route("/opms/form/registration-form/validate/ids", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostValidateWithIds implements IReturn<RegistrationFormValidationResponse>
{
    [immerable]? = true;

    /** @description The registration form to validate. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    /** @description The ID of the Institution associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormValidationResponse(); }
}

// @Route("/opms/form/registration-form/validate/codes", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostValidateWithCodes implements IReturn<RegistrationFormValidationResponse>
{
    [immerable]? = true;

    /** @description The registration form to validate. */
    // @DataMember(Order=1)
    public form: RegistrationForm;

    /** @description The Code of the Institution associated with the registration form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the registration form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the registration form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormValidationResponse(); }
}

// @Route("/opms/form/registration-form/update-status/", "POST")
// @Api(Description="Form - Registration Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class RegistrationFormPostUpdateStatusByIds implements IReturn<RegistrationFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the registration form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the registration form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the registration form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the registration form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the registration form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<RegistrationFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationFormUpdateStatusResponse(); }
}

// @Route("/opms/form/visit-details-form/single/id/{Id}", "GET")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormGetSingleById implements IReturn<VisitDetailsFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<VisitDetailsFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VisitDetailsFormSingleResponse(); }
}

// @Route("/opms/form/visit-details-form/single/ids", "GET")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormGetSingleByIds implements IReturn<VisitDetailsFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the visit details form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the visit details form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new visit details form if no visit details form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<VisitDetailsFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VisitDetailsFormSingleResponse(); }
}

// @Route("/opms/form/visit-details-form/single/codes", "GET")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormGetSingleByCodes implements IReturn<VisitDetailsFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the visit details form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the visit details form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new visit details form if no visit details form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<VisitDetailsFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VisitDetailsFormSingleResponse(); }
}

// @Route("/opms/form/visit-details-form/collection", "GET")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormGetCollection implements IReturn<VisitDetailsFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<VisitDetailsFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VisitDetailsFormCollectionResponse(); }
}

// @Route("/opms/form/visit-details-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormGetCollectionByIds implements IReturn<VisitDetailsFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<VisitDetailsFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VisitDetailsFormCollectionResponse(); }
}

// @Route("/opms/form/visit-details-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormCollectionResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormGetCollectionByCodes implements IReturn<VisitDetailsFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the visit details form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<VisitDetailsFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VisitDetailsFormCollectionResponse(); }
}

// @Route("/opms/form/visit-details-form/save", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostSave implements IReturn<VisitDetailsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The visit details form to save. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    public constructor(init?: Partial<VisitDetailsFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormSingleResponse(); }
}

// @Route("/opms/form/visit-details-form/save/ids", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostSaveWithIds implements IReturn<VisitDetailsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The visit details form to save. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    /** @description The ID of the Institution associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the visit details form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<VisitDetailsFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormSingleResponse(); }
}

// @Route("/opms/form/visit-details-form/save/codes", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormSingleResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostSaveWithCodes implements IReturn<VisitDetailsFormSingleResponse>
{
    [immerable]? = true;

    /** @description The visit details form to save. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    /** @description The Code of the Institution associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the visit details form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the visit details form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<VisitDetailsFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormSingleResponse(); }
}

// @Route("/opms/form/visit-details-form/delete", "DELETE")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormDelete implements IReturn<VisitDetailsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The visit details form to delete. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    public constructor(init?: Partial<VisitDetailsFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new VisitDetailsFormDeleteResponse(); }
}

// @Route("/opms/form/visit-details-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormDeleteWithId implements IReturn<VisitDetailsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<VisitDetailsFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new VisitDetailsFormDeleteResponse(); }
}

// @Route("/opms/form/visit-details-form/delete/ids", "DELETE")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormDeleteWithIds implements IReturn<VisitDetailsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the visit details form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<VisitDetailsFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new VisitDetailsFormDeleteResponse(); }
}

// @Route("/opms/form/visit-details-form/delete/codes", "DELETE")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormDeleteResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormDeleteByCodes implements IReturn<VisitDetailsFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the visit details form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the visit details form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<VisitDetailsFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new VisitDetailsFormDeleteResponse(); }
}

// @Route("/opms/form/visit-details-form/validate", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostValidate implements IReturn<VisitDetailsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The visit details form to validate. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    public constructor(init?: Partial<VisitDetailsFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormValidationResponse(); }
}

// @Route("/opms/form/visit-details-form/validate/ids", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostValidateWithIds implements IReturn<VisitDetailsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The visit details form to validate. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    /** @description The ID of the Institution associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<VisitDetailsFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormValidationResponse(); }
}

// @Route("/opms/form/visit-details-form/validate/codes", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormValidationResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostValidateWithCodes implements IReturn<VisitDetailsFormValidationResponse>
{
    [immerable]? = true;

    /** @description The visit details form to validate. */
    // @DataMember(Order=1)
    public form: VisitDetailsForm;

    /** @description The Code of the Institution associated with the visit details form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the visit details form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the visit details form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the visit details form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<VisitDetailsFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormValidationResponse(); }
}

// @Route("/opms/form/visit-details-form/update-status/", "POST")
// @Api(Description="Form - Visit Details Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.VisitDetailsFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.VisitDetailsFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.VisitDetailsFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.VisitDetailsFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.VisitDetailsFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class VisitDetailsFormPostUpdateStatusByIds implements IReturn<VisitDetailsFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the visit details form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the visit details form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the visit details form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the visit details form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the visit details form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<VisitDetailsFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VisitDetailsFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VisitDetailsFormUpdateStatusResponse(); }
}

// @Route("/opms/form/withdrawal-form/single/id/{Id}", "GET")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormGetSingleById implements IReturn<WithdrawalFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<WithdrawalFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalFormSingleResponse(); }
}

// @Route("/opms/form/withdrawal-form/single/ids", "GET")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormGetSingleByIds implements IReturn<WithdrawalFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the withdrawal form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new withdrawal form if no withdrawal form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<WithdrawalFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalFormSingleResponse(); }
}

// @Route("/opms/form/withdrawal-form/single/codes", "GET")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormGetSingleByCodes implements IReturn<WithdrawalFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the withdrawal form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new withdrawal form if no withdrawal form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<WithdrawalFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalFormSingleResponse(); }
}

// @Route("/opms/form/withdrawal-form/collection", "GET")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormGetCollection implements IReturn<WithdrawalFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<WithdrawalFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalFormCollectionResponse(); }
}

// @Route("/opms/form/withdrawal-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormGetCollectionByIds implements IReturn<WithdrawalFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalFormCollectionResponse(); }
}

// @Route("/opms/form/withdrawal-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormCollectionResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormGetCollectionByCodes implements IReturn<WithdrawalFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalFormCollectionResponse(); }
}

// @Route("/opms/form/withdrawal-form/save", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostSave implements IReturn<WithdrawalFormSingleResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to save. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    public constructor(init?: Partial<WithdrawalFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormSingleResponse(); }
}

// @Route("/opms/form/withdrawal-form/save/ids", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostSaveWithIds implements IReturn<WithdrawalFormSingleResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to save. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    /** @description The ID of the Institution associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the withdrawal form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<WithdrawalFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormSingleResponse(); }
}

// @Route("/opms/form/withdrawal-form/save/codes", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostSaveWithCodes implements IReturn<WithdrawalFormSingleResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to save. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    /** @description The Code of the Institution associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the withdrawal form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<WithdrawalFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormSingleResponse(); }
}

// @Route("/opms/form/withdrawal-form/delete", "DELETE")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormDelete implements IReturn<WithdrawalFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to delete. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    public constructor(init?: Partial<WithdrawalFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalFormDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormDeleteWithId implements IReturn<WithdrawalFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<WithdrawalFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalFormDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-form/delete/ids", "DELETE")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormDeleteWithIds implements IReturn<WithdrawalFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<WithdrawalFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalFormDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-form/delete/codes", "DELETE")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormDeleteByCodes implements IReturn<WithdrawalFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the withdrawal form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<WithdrawalFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalFormDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-form/validate", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostValidate implements IReturn<WithdrawalFormValidationResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to validate. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    public constructor(init?: Partial<WithdrawalFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormValidationResponse(); }
}

// @Route("/opms/form/withdrawal-form/validate/ids", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostValidateWithIds implements IReturn<WithdrawalFormValidationResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to validate. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    /** @description The ID of the Institution associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormValidationResponse(); }
}

// @Route("/opms/form/withdrawal-form/validate/codes", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormValidationResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostValidateWithCodes implements IReturn<WithdrawalFormValidationResponse>
{
    [immerable]? = true;

    /** @description The withdrawal form to validate. */
    // @DataMember(Order=1)
    public form: WithdrawalForm;

    /** @description The Code of the Institution associated with the withdrawal form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the withdrawal form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the withdrawal form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormValidationResponse(); }
}

// @Route("/opms/form/withdrawal-form/update-status/", "POST")
// @Api(Description="Form - Withdrawal Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class WithdrawalFormPostUpdateStatusByIds implements IReturn<WithdrawalFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the withdrawal form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the withdrawal form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the withdrawal form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the withdrawal form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the withdrawal form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<WithdrawalFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalFormUpdateStatusResponse(); }
}

// @Route("/opms/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download-all/{PatientId}/{FormDefinitionId}/{FormId}", "GET")
export class DownloadAllFiles implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;

    public constructor(init?: Partial<DownloadAllFiles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadAllFiles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/query/single/id/{Id}", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=500)
// @DataContract
export class QueryGetSingleById implements IReturn<QuerySingleResponse>, IQueryGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the query to retrieve. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<QueryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySingleResponse(); }
}

// @Route("/opms/query/collection", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=500)
// @DataContract
export class QueryGetCollection implements IReturn<QueryCollectionResponse>, IQueryGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<QueryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCollectionResponse(); }
}

// @Route("/opms/query/collection/form-definition/id/{FormDefinitionId}/form/id/{FormId}", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=500)
// @DataContract
export class QueryGetCollectionByForm implements IReturn<QueryCollectionResponse>, IQueryGetCollectionByForm
{
    [immerable]? = true;

    /** @description The ID of the Form Definition associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId: number;

    /** @description The ID of the Form associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formId: number;

    public constructor(init?: Partial<QueryGetCollectionByForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetCollectionByForm'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCollectionResponse(); }
}

// @Route("/opms/query/collection/form-definition/id/{FormDefinitionId}/form/id/{FormId}/property-path/{PropertyPath}", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=500)
// @DataContract
export class QueryGetCollectionByFormProperty implements IReturn<QueryCollectionResponse>, IQueryGetCollectionByFormProperty
{
    [immerable]? = true;

    /** @description The ID of the Form Definition associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId: number;

    /** @description The ID of the Form associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formId: number;

    /** @description The property path associated with the query to retrieve. */
    // @DataMember(Order=1)
    public propertyPath: string;

    public constructor(init?: Partial<QueryGetCollectionByFormProperty>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetCollectionByFormProperty'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCollectionResponse(); }
}

// @Route("/opms/query/save", "POST")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=500)
// @DataContract
export class QueryPostSave implements IReturn<QuerySingleResponse>
{
    [immerable]? = true;

    /** @description The query to save. */
    // @DataMember(Order=1)
    public query: Query;

    public constructor(init?: Partial<QueryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuerySingleResponse(); }
}

// @Route("/opms/form/query/validate", "POST")
// @Api(Description="Query - Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=500)
// @DataContract
export class QueryPostValidate implements IReturn<QueryValidationResponse>
{
    [immerable]? = true;

    /** @description The query to validate. */
    // @DataMember(Order=1)
    public query: Query;

    public constructor(init?: Partial<QueryPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueryValidationResponse(); }
}

// @Route("/opms/query/delete/id/{QueryId}", "DELETE")
// @Api(Description="Query - Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=500)
// @DataContract
export class QueryDeleteById implements IReturn<QueryDeleteResponse>, IQueryDeleteById
{
    [immerable]? = true;

    /** @description The ID of the query to delete. */
    // @DataMember(Order=1)
    public queryId: number;

    public constructor(init?: Partial<QueryDeleteById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryDeleteById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new QueryDeleteResponse(); }
}

// @Route("/opms/subquery/collection/query/id/{QueryId}", "GET")
// @Api(Description="Subquery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=500)
// @DataContract
export class SubqueryGetCollectionByQueryId implements IReturn<SubqueryCollectionResponse>, ISubqueryGetCollectionByQueryId
{
    [immerable]? = true;

    /** @description The ID of the Query associated with the subquery to retrieve. */
    // @DataMember(Order=1)
    public queryId: number;

    public constructor(init?: Partial<SubqueryGetCollectionByQueryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubqueryGetCollectionByQueryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SubqueryCollectionResponse(); }
}

// @Route("/opms/subquery/save", "POST")
// @Api(Description="Subquery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=500)
// @DataContract
export class SubqueryPostSave implements IReturn<SubquerySingleResponse>
{
    [immerable]? = true;

    /** @description The subquery to save. */
    // @DataMember(Order=1)
    public subquery: Subquery;

    public constructor(init?: Partial<SubqueryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubqueryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SubquerySingleResponse(); }
}

// @Route("/opms/event-state/id/{Id}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesById implements IReturn<EventStateResponse>, IPatientGetEventStatesById
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventStatesById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/event-state/study-number/{StudyNumber}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesByStudyNumber implements IReturn<EventStateResponse>, IPatientGetEventStatesByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<EventStatesByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/form-state/ids/{Id}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=500)
// @DataContract
export class FormStatesByIds implements IReturn<FormStateResponse>, IPatientGetFormStatesByIds
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description The event definition ID of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The event repeat of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    public constructor(init?: Partial<FormStatesByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormStatesByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormStateResponse(); }
}

export class GetUserPermissions implements IReturn<UserPermissionsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetUserPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserPermissionsResponse(); }
}

export class PostHasOpmsPermissionsByIds implements IReturn<HasOpmsPermissionCollectionResponse>
{
    [immerable]? = true;

    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public patientId?: number;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class PostHasOpmsPermissionsByCodes implements IReturn<HasOpmsPermissionCollectionResponse>
{
    [immerable]? = true;

    public masterGroupCode: string;
    public coordinatingGroupCode: string;
    public institutionCode: string;
    public patientStudyNumber: string;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class GetInstitutionPersonnelEmailAddresses implements IReturn<InstitutionPersonnelEmailAddressesResponse>, IGet
{
    [immerable]? = true;

    public institutionCode: string;
    public roles: number[];
    public ids: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelEmailAddresses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnelEmailAddresses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelEmailAddressesResponse(); }
}

export class GetInstitutionPersonnel implements IReturn<InstitutionPersonnelResponse>, IGet
{
    [immerable]? = true;

    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelResponse(); }
}

export class GetInstitutionPersonnelNames implements IReturn<InstitutionPersonnelNamesResponse>, IGet
{
    [immerable]? = true;

    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelNames>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnelNames'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelNamesResponse(); }
}

export class GetTrialPersonnelHasActiveRole implements IReturn<TrialPersonnelActiveRoleResponse>, IGet
{
    [immerable]? = true;

    public personId: number;
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetTrialPersonnelHasActiveRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelHasActiveRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialPersonnelActiveRoleResponse(); }
}

export class GetUserPersonnelEmailAddress implements IReturn<UserPersonnelEmailAddressResponse>, IGet
{
    [immerable]? = true;

    public userName: string;

    public constructor(init?: Partial<GetUserPersonnelEmailAddress>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserPersonnelEmailAddress'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserPersonnelEmailAddressResponse(); }
}

